function initHeaderContrast() {
  const header = document.querySelector("[data-site-header]");
  if (!header) return;

  if (header._contrastScrollHandler) {
    document.body.removeEventListener("scroll", header._contrastScrollHandler);
    window.removeEventListener("resize", header._contrastScrollHandler);
    header._contrastScrollHandler = null;
  }

  const themedSections = Array.from(
    document.querySelectorAll("[data-header-theme]")
  );

  function updateHeaderContrast() {
    if (!themedSections.length) {
      header.classList.add("is-dark");
      return;
    }

    const probeY = header.offsetHeight * 0.5;
    let activeTheme = "dark";

    for (const section of themedSections) {
      const rect = section.getBoundingClientRect();

      if (rect.top <= probeY && rect.bottom >= probeY) {
        activeTheme = section.dataset.headerTheme || "dark";
        break;
      }
    }

    if (activeTheme === "light") {
      header.classList.remove("is-dark");
    } else {
      header.classList.add("is-dark");
    }
  }

  updateHeaderContrast();

  header._contrastScrollHandler = updateHeaderContrast;
  document.body.addEventListener("scroll", updateHeaderContrast, { passive: true });
  window.addEventListener("resize", updateHeaderContrast);
}

document.addEventListener("DOMContentLoaded", initHeaderContrast);
document.addEventListener("shopify:section:load", initHeaderContrast);
document.addEventListener("shopify:section:reorder", initHeaderContrast);
document.addEventListener("shopify:section:select", initHeaderContrast);